const translations = {
  "en": {
    "Alpha Unlocked": "Alpha Unlocked",
    "Analysis Credits": "Analysis Credits",
    "Congrats!": "Congrats!",
    "Earnings Strategy": "Earnings Strategy",
    "Enter Alpha": "Enter Alpha",
    "Got it !": "Got it !",
    "HK IPO Strategy": "HK IPO Strategy",
    "Latest Edgen's Pick": "Latest Ed's Pick",
    "Obtained the following benefits": "Obtained the following benefits",
    "Your starter pack is ready.": "Your starter pack is ready."
  },
  "zh-tw": {
    "Alpha Unlocked": "Alpha 解鎖",
    "Analysis Credits": "分析點數",
    "Congrats!": "恭喜 !",
    "Earnings Strategy": "獲利策略",
    "Enter Alpha": "進入 Alpha",
    "Got it !": "了解！",
    "HK IPO Strategy": "香港IPO策略",
    "Latest Edgen's Pick": "最新 Ed 的精選推薦",
    "Obtained the following benefits": "獲得以下利益",
    "Your starter pack is ready.": "新手禮包已存入賬戶"
  }
};

export default translations;
